 /**
  * Interface for services that provide dropdown data sources
  */
export interface IDropdownDatasourceService {

  /**
   * Initializes dropdown options for columns with dropdown editors
   * @param columns Array of column definitions that may include dropdown editors
   */
  initializeDropdowns(columns: Array<{
    columnDef: string;
    editInline?: boolean;
    editInlineComponentType?: 'dropdown' | 'text' | 'datepicker';
    [key: string]: any;
  }>): void;
  
  /**
   * Gets the dropdown options for a specific column
   * @param columnDef Column definition identifier
   * @returns Array of dropdown options with label and value pairs
   */
  getDropdownDataSource(columnDef: string): Array<{
    label: string;
    value: any;
  }>;
}

interface StaticOption {
  label: string;
  value: string | number | boolean | object;
}

interface HttpHeader {
  key: string;
  value: string;
}

interface BaseColumnFunction {
  dataSourceType: 'static' | 'url';
}

interface StaticColumnFunction extends BaseColumnFunction {
  dataSourceType: 'static';
  options: StaticOption[];
}

export interface UrlColumnFunction extends BaseColumnFunction {
  dataSourceType: 'url';
  httpMethod: 'GET' | 'POST' | 'PUT' | 'DELETE';
  headers?: HttpHeader[];
  dataSourceUrl: string;
  idPath?: string;
  dataPath: string;
  labelProperty: string;
  valueProperty: string;
}

type ColumnFunction = StaticColumnFunction | UrlColumnFunction;

export interface ColumnFunctionMap {
  [columnKey: string]: ColumnFunction;
}